import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsProps } from 'antd';
import Wrapper from '../index';
import Confirm from './Confirm';
import Payment from './Payment';
import SelectPlan from './SelectPlan';
import { usePlans } from '../../../../hooks/stripe';
import { useContextNotifications } from '../../../../context/notifications';
import useTrialDaysLeft from '../../../../hooks/useTrialDaysLeft';
import { useAuth } from '../../../../context/auth';

const Setup = () => {
  const navigate = useNavigate();
  const trialDaysLeft = useTrialDaysLeft();
  const [key, setKey] = useState<number>(1);
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string | null>(null);
  const [discount, setDiscount] = useState<string>();
  const getPlans = usePlans();
  const { openNotification } = useContextNotifications();
  const { user, isPlanExists } = useAuth();
  const [coupon, setCoupon] = useState<string>();

  const paymentSetupRequired = Boolean(user?.paymentSetupRequired);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const plansResponse = await getPlans.fetch({ type: 'month' });
        const planData = plansResponse?.data || [];

        if (planData.length > 0) {
          const sortedPlans = [...planData].sort((a, b) => (a.amount || 0) - (b.amount || 0));

          setSelectedPlan(sortedPlans[0]?.id);
        }
      } catch (error) {
        openNotification?.({ message: `Error fetching plans: ${error}`, type: 'error' });
      }
    };

    fetchPlans();
  }, []);

  const handleNext = () => {
    setKey((prev) => prev + 1);
  };

  const handleBack = () => {
    setKey((prev) => prev - 1);
    // navigate('/profile?tab=payment')
  };

  // const handlePlanChange = (id: string, newpromoCode?: string) => {
  //   setSelectedPlan(id);
  //   setpromoCode(newpromoCode);
  //   handleNext();
  // };

  const handlePaymentMethodSelect = (id: string | null) => {
    setSelectedPaymentMethod(id);
    handleNext();
  };

  const handlePlanChange = (id: string, newCoupon?: string) => {
    setSelectedPlan(id);
    setCoupon(newCoupon);
    handleNext();
  };

  const getTitle = () => {
    if (paymentSetupRequired) {
      return "$99/month – Full Access"
    }

    if (trialDaysLeft) {
      return `Activate your plan now for $99/month — no interruptions, full access`
    }

    return `Your Free Trial Has Ended
      Keep access to Mortgage Maker for $99/month`
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: '',
      children: (
        <Wrapper title="Choose Your Billing Option">
          <SelectPlan handleNext={handlePlanChange} setDiscount={setDiscount} />
        </Wrapper>
      ),
    },
    {
      key: '2',
      label: '',
      children: (
        <Wrapper title="Add payment method" text="Get Mortgage Maker to manage you work">
          <Payment
            selectedPaymentMethod={selectedPaymentMethod}
            handleNext={handlePaymentMethodSelect}
            handleBack={handleBack}
          />
        </Wrapper>
      ),
    },
    {
      key: '3',
      label: '',
      children: (
        <Wrapper title="Confirm your details">
          <Confirm
            selectedPlan={selectedPlan}
            selectedPaymentMethod={selectedPaymentMethod}
            handleBack={handleBack}
            promoCode={coupon}
            discount={discount}
          />
        </Wrapper>
      ),
    },
  ];

  return  (
    <Tabs
      tabPosition="bottom"
      centered
      tabBarGutter={10}
      tabBarStyle={{ borderRadius: 4, height: 5 }}
      className="steps"
      activeKey={key.toString()}
      items={items}
    />
  )

  // return (
  //     <Wrapper
  //       title={getTitle()}
  //       text={paymentSetupRequired ? 'Backed by our 30-Day Money Back Guarantee' : ''}
  //       titleStyle={{
  //         whiteSpace: "pre-line",
  //         textAlign: "center",
  //       }}
  //     >
  //       <Payment
  //         selectedPaymentMethod={selectedPaymentMethod}
  //         handleNext={handlePaymentMethodSelect}
  //         handleBack={handleBack}
  //         selectedPlan={selectedPlan}
  //         discount={discount}
  //         plan={plan}
  //       />
  //     </Wrapper>
  // );
};

export default Setup;
